import moment from 'moment';

export const humanizeDuration = (endTime, startTime) => {
  if (!endTime) return null;
  let duration = endTime;
  if (endTime && startTime) {
    duration = new Date(endTime).getTime() - new Date(startTime).getTime();
  }
  const durationSeconds = moment.duration(duration).seconds();
  const durationMinutes = moment.duration(duration).minutes();
  return `${
    durationMinutes ? `${durationMinutes} min ` : ``
  }${durationSeconds} sec`;
};

const getHoursLabels = () => {
  const hoursCount = 24;
  const hoursLabels = {};

  for (let i = 0; i < hoursCount; i += 1) {
    hoursLabels[`${i}:00`] = 0;
  }

  return hoursLabels;
};

export const getFrequencyStats = (calls) => {
  const hoursLabels = getHoursLabels();
  if (!calls?.length) return hoursLabels;

  return calls.reduce((hours, call) => {
    const hoursOut = hours;
    const creationHour = new Date(call?.createdAt)?.getHours();
    const creationHourLabel = `${creationHour}:00`;
    const isHourAdded = Boolean(hours[creationHourLabel]);
    hoursOut[creationHourLabel] = isHourAdded
      ? hours[creationHourLabel] + 1
      : 1;
    return hoursOut;
  }, hoursLabels);
};
